import React from 'react';

const SectionCenterSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fill="#010101"
            d="M9 17h6v2H9v-2zm-1 3h8v-4H8v4zM4 10v4h16v-4H4zm15 3H5v-2h14v2zM4 4v4h16V4H4zm15 3H5V5h14v2z"
        />
    </svg>
);

SectionCenterSvg.displayName = 'SectionCenterSvg';
export default SectionCenterSvg;
